import { useSelector } from "react-redux";
import { useAuthStore } from "./auth";
import store from "../storeWire";
import {
    addCartInBulk, getMrfCodeToValidateToShip, getVatData, getCalculatedVatData, getCartSubTotal, SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE, getQuoteCartSubTotal, getQuoteCalculatedVatData, SET_CART_DATA_ERROR,
    addToCartServer,
    checkQuoteCartItemBlackListed
} from "../store/slice/model/Cart";
import CartService from "../service/Cart";
import CartRepository from "src/repository/CartRepository";
import System from "src/helper/system";

export function useCartStore() {
    const [{ SHIPPING_ADDRESS_LIST }, { shipping_address_list }, { shipping_address_id, default_shipping_address_id }] = useAuthStore();
    const CART_SHIPPING_ADDRESS_ID = useSelector((state) => state.entities.Cart.CART_SHIPPING_ADDRESS_ID);
    const CART_DATA = useSelector((state) => state.entities.Cart.CART_DATA);
    const CART_DATA_OBJECT = useSelector((state) => state.entities.Cart.CART_DATA_OBJECT);
    const CART_PRODUCT_DATA = useSelector((state) => state.entities.Cart.CART_PRODUCT_DATA);
    const CART_READY_TO_GO_FOR_CHECKOUT = useSelector((state) => state.entities.Cart.CART_READY_TO_GO_FOR_CHECKOUT);
    const CART_PRODUCT_INVENTORY_DATA = useSelector((state) => state.entities.Cart.CART_PRODUCT_INVENTORY_DATA);
    const CART_PRODUCT_PRICING_DATA = useSelector((state) => state.entities.Cart.CART_PRODUCT_PRICING_DATA);
    const CART_BEFORE_TO_SEND_SERVER = useSelector((state) => state.entities.Cart.CART_BEFORE_TO_SEND_SERVER);
    const CART_PRICE_BEFORE_TO_SEND_SERVER = useSelector((state) => state.entities.Cart.CART_PRICE_BEFORE_TO_SEND_SERVER);
    const VAT_DATA = useSelector((state) => state.entities.Cart.VAT_DATA);
    const MFR_CODE_LIST_SHIP_TO_VALIDATE = useSelector((state) => state.entities.Cart.MFR_CODE_LIST_SHIP_TO_VALIDATE);
    const SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE = useSelector((state) => state.entities.Cart.SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE);
    const CART_LOADER_DATA_OBJECT = useSelector((state) => state.entities.Cart.CART_LOADER_DATA_OBJECT);
    const CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = useSelector((state) => state.entities.Cart.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER);
    const CART_DATA_ERROR = useSelector((state) => state.entities.Cart.CART_DATA_ERROR);
    const ADD_CART_DATA = useSelector((state) => state.entities.Cart.ADD_CART_DATA);
    const CART_COUNT = useSelector((state) => state.entities.Cart.CART_COUNT);
    const WEB_ORDER_ID = useSelector((state) => state.entities.Cart.WEB_ORDER_ID);
    const QUOTE_CART_BLACKLISTED_ARR = useSelector((state) => state.entities.Cart.QUOTE_CART_BLACKLISTED_ARR);

    let data = {
        CART_SHIPPING_ADDRESS_ID,
        CART_DATA,
        CART_DATA_OBJECT,
        CART_PRODUCT_DATA,
        CART_READY_TO_GO_FOR_CHECKOUT,
        CART_PRODUCT_INVENTORY_DATA,
        CART_PRODUCT_PRICING_DATA,
        CART_BEFORE_TO_SEND_SERVER,
        CART_PRICE_BEFORE_TO_SEND_SERVER,
        VAT_DATA,
        MFR_CODE_LIST_SHIP_TO_VALIDATE,
        // CALCULATED_VAT_DATA,
        // CART_SUBTOTAL,
        SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE,
        SHIPPING_ADDRESS_LIST,
        CART_LOADER_DATA_OBJECT,
        CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER,
        // CHECKOUT_DATA,
        CART_DATA_ERROR,
        ADD_CART_DATA,
        CART_COUNT,
        WEB_ORDER_ID,
        QUOTE_CART_BLACKLISTED_ARR
    };
    let fetch = {
        shipping_address_list: async () => {
            return await shipping_address_list();
        },

        get_vat_data: async () => {
            return await store.dispatch(getVatData())
        },
        get_Mfr_code_validate_to_ship: async (countryCode) => {
            return await store.dispatch(getMrfCodeToValidateToShip(countryCode))
        },
        get_cart_list_subtotal: (cart_data) => { // Remove dependency of Thunk & redux - Optimozed for get_cart_subtotal
            return new CartRepository().getCartListSubTotal(cart_data)
        },
        get_vat_total: (cartlist, vatData) => { // Remove dependency of Thunk & redux - Optimozed for get_cart_subtotal
            return new CartRepository().getVatTotal(cartlist, vatData)
        },
        get_quote_cart_subtotal: (cart_data) => {
            return new CartRepository().getQuoteCartSubTotal(cart_data)
        },
        get_is_any_invalid_product: (quoteNumber) => {
            return new CartRepository().checkisAnyInvalidProduct(quoteNumber)
        },
        check_item_exists_in_cart: (params) => {
            return new CartRepository().checkItemExistsInCart(params)
        },
        get_quote_currency: (quoteList) => {
            let cur = window.mct;
            if (quoteList && Object.entries(quoteList).length > 0) {
                cur = Object.entries(quoteList)[0][1].currency_0;
            }
            return cur;
        },
        get_updated_qty: (product, CART_BEFORE_TO_SEND_SERVER) => {
            return new CartRepository().getUpdatedQty(product, CART_BEFORE_TO_SEND_SERVER)
        },
        get_selected_shipping_address: () => {
            return new CartRepository().getShippingAddress();
        },
        fetch_cart_count: async () => {
            return await new CartRepository().fetchCartCount()
        },
        fetch_cart_data: async (param = {}) => {
            return await new CartRepository().fetchCartData(false, param)
        },
        fetch_products_for_cart_by_cart_global_state: async () => {
            await new CartRepository().fetchProductsForCartByCartGlobalState();
        },
        fetch_products_inventory_for_cart_by_cart_product_global_state: async () => {
            await new CartRepository().fetchProductsInventoryForCartByCartProductGlobalState();
        },
        fetchProductsPricingForCartByCartProductGlobalState: async () => {
            await new CartRepository().fetchProductsPricingForCartByCartProductGlobalState();
        },
        get_cart_quote_number: () => {
            const c = System.getParams();
            return c.quote_number;
        },
        get_checkout_charge: async () => {
            return await new CartRepository().getCheckoutCharge();
        },
        initiatedKernelCall: async (params) => {
            await new CartRepository().initiatedKernelCall(params);
        },
        initiatedKernelSyncCurrencyCall: async () => {
            let d = await new CartRepository().syncCurrencyChange();
            if (d === 'SYNCED_NOW') {
                await new CartRepository().fetchCartData();
            }
        },
        check_item_blacklist_country: async (params) => {
            return await store.dispatch(checkQuoteCartItemBlackListed(params))
        }
    };
    let set = {
        default_shipping_address_id: async (defaultAddressId) => {
            return await default_shipping_address_id(defaultAddressId)
        },
        shipping_address_id: async (shipToAddressId) => {
            return await shipping_address_id(shipToAddressId)
        },
        add_cart_in_Bulk: async (params) => {
            return await store.dispatch(addCartInBulk(params))
        },
        SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE: async (params) => {
            return await store.dispatch(SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE(params))
        },
        SET_CART_DATA_ERROR: async (params) => {
            return await store.dispatch(SET_CART_DATA_ERROR(params))
        },
        replace_cart_in_Bulk: async (params, isBulk = false) => {
            return new CartRepository().replaceCartInBulk(params, isBulk)
        },
        SET_SELECTED_SHIPPING_ADDRESS: (addressList, shippingAddressId) => {
            return new CartRepository().setShippingAddress(addressList, shippingAddressId)
        },
        CLEAR_CART: async () => {
            await new CartRepository().clearAllCartFromServer();
            await new CartRepository().fetchCartCount();
            await new CartRepository().fetchCartData();
        },
        ADD_TO_CART: async (param, isManuallyAddCart) => {
            await new CartRepository().addToCartServer(param, isManuallyAddCart);
        }

    };

    let exportCartItems = {
        export_cart_data: async (fileType) => {
            return await new CartService().exportCartData(fileType)
        }
    }

    return [data, fetch, set, exportCartItems]
}